import { render, staticRenderFns } from "./SetLanguageToast.vue?vue&type=template&id=ae56efcc&scoped=true&"
import script from "./SetLanguageToast.vue?vue&type=script&lang=js&"
export * from "./SetLanguageToast.vue?vue&type=script&lang=js&"
import style0 from "./SetLanguageToast.vue?vue&type=style&index=0&id=ae56efcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae56efcc",
  null
  
)

export default component.exports